import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

const ImageBackground = styled.img`
  max-width: 100%;
  position: relative;
  display: block;
  z-index: -1;
  margin-bottom: 20vh;
`

const ImageCurtain = styled.div`
  position: relative;
  background-color: rgba(34, 34, 34, 0.8);
`

const BannerText = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: "PT sans", sans-serif;

  h1 {
    font-size: 2.1rem;
    margin: 0;
    user-select: none;
    @media screen and (min-width: 768px) {
      font-size: 2.5rem;
    }
  }

  p {
    font-size: 1.2rem;
    margin: 0;
    width: 350px;
    text-align: center;
    user-select: none;
    @media screen and (min-width: 768px) {
      width: 700px;
      font-size: 2.5rem;
    }
  }
`

const Banner = () => {
  const { banner } = useStaticQuery(graphql`
    query {
      banner: file(relativePath: { eq: "banner3.png" }) {
        sharp: childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <ImageCurtain>
      <ImageBackground srcSet={banner.sharp.fluid.srcSet} />
      <BannerText>
        <h1>Dorian Desings</h1>
        <p>Aprende desarrollo web desde la base y con buenas prácticas</p>
      </BannerText>
    </ImageCurtain>
  )
}

export default Banner
